<template>
  <Base>
    <template v-slot:contentBase>

      <div class="panel panel-success" ref="pdfContent">
        <div class="panel-heading">
          <h3>
            <i class="fa fa-eye"></i>
            {{ dados.SUBTITULO }}
          </h3>
        </div>
        <div class="panel-body">
          <div @click="gerarPdf">
            <button class="btn btn-danger btn-sm"><i class="fa fa-file-pdf-o"></i> Gerar PDF</button>
            <br>
          </div>

          <template v-for="construcao in dados.construcoes">
            <div class="row">
              <div class="col-md-12">
                <h4><strong>Construção: {{ construcao.construcao }}</strong></h4>
                <span><strong>Data de inicio: {{ construcao.data_inicio }} |</strong></span>
                <span><strong>Previsão de término: {{ construcao.data_termino_previsao }}</strong></span>
                <span v-if="construcao.data_termino"><strong>| Data do término: {{
                    construcao.data_termino
                  }}</strong></span>
                <hr>
              </div>
            </div>

            <template v-for="etapa in dados.etapas">
              <template v-if="construcao.construcao_id === etapa.id_construcao">
                <div class="row">
                  <div class="col-md-12 offset-1">
                    <h4><strong>- {{ etapa.etapa }}</strong></h4>
                    <hr>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-10 offset-2">
                    <table class="table table-striped table-bordered table-hover dataTables-example">
                      <thead>
                      <tr>
                        <th>DESCRIÇÃO</th>
                        <th>UNIDADE</th>
                        <th>QUANTIDADE</th>
                        <th>VALOR</th>
                      </tr>
                      </thead>
                      <tbody>

                      <template v-for="material in dados.materiais" :key="material.id">
                        <template v-if="material.id_etapa === etapa.etapa_id">
                          <tr>
                            <td>{{ material.material }}</td>
                            <td>{{ material.unidade }}</td>
                            <td class="text-right">{{ material.quantidade }}</td>
                            <td class="text-right">{{ material.valor }}</td>
                          </tr>
                        </template>
                      </template>
                      <!-- Subtotal Etapas Material -->
                      <tr>
                        <td colspan="4">
                          <strong>Subtotal:</strong>
                          <strong class="pull-right">{{ etapa.subtotal }}</strong>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </template>
            </template>

            <!-- Total Construção -->
            <div class="row">
              <div class="col-md-11 offset-1">
                <hr>
                <h4>
                  <strong>Total construção:</strong>
                  <strong class="pull-right">{{ construcao.total_construcao }}</strong>
                </h4>
                <hr>
              </div>
            </div>
          </template>
          <!-- Total Geral -->
          <div class="row">
            <div class="col-md-12">
              <hr>
              <h4>
                <strong>Total geral:</strong>
                <strong class="pull-right">{{ dados.total_geral }}</strong>
              </h4>
            </div>
          </div>
          <br>
        </div>
      </div>


    </template>
  </Base>
</template>

<script>

import {defineComponent} from "vue";
import Base from "@/components/base/Base.vue";
import pdfMake from "pdfmake";
import htmlToPdfmake from "html-to-pdfmake";

export default defineComponent({
  name: "PdfRelatorio",
  components: {
    Base,
  },
  data() {
    return {
      dados: history.state?.dados || [],

    }
  },
  methods: {
    gerarPdf() {
      const el = this.$refs.pdfContent;
      const html = el.innerHTML;
      const pdfContent = htmlToPdfmake(html);

      const docDefinition = {
        content: pdfContent,
        styles: {
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black"
          }
        }
      };

      pdfMake.createPdf(docDefinition).download("relatorio.pdf");
    },
  },
})
</script>
